import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { Contact } from './../models/index';
import { SeoAwareBaseComponent } from './../seo/seo-aware-base.component';

@Injectable()
export class ContactService {
  constructor(private apiCallService: ApiCallService) { }

  sendToAgency(contact: Contact): Promise<any> {
    this.setTracking(contact)
    return this.apiCallService.post('/contact', contact);
  }

  sendToProperty(friendlyId: string | number, contact: Contact): Promise<any> {
    this.setTracking(contact);
    return this.apiCallService.post('/contact?property_friendly_id=' + friendlyId, contact);
  }

  sendToApartmentType(friendlyId: string | number, contact: Contact): Promise<any> {
    this.setTracking(contact);
    return this.apiCallService.post('/contact?apartment_type_friendly_id=' + friendlyId, contact);
  }

  sendToProject(projectId: number, contact: Contact): Promise<any> {
    this.setTracking(contact);
    return this.apiCallService.post('/contact?project_id=' + projectId, contact);
  }

  setTracking(contact: Contact): void {
    contact.referrer_url = SeoAwareBaseComponent.referrer_url;
    contact.utm_source = SeoAwareBaseComponent.utm_source;
    contact.utm_medium = SeoAwareBaseComponent.utm_medium;
    contact.utm_campaign = SeoAwareBaseComponent.utm_campaign;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/contact.service.ts